/**
 * Save a file that came back from axios with responseType 'blob', and read the
 * error text of a failed blob request (its body is a Blob too).
 */
export function saveBlob(data: BlobPart, fileName: string): void {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export async function blobErrorMessage(err: any, fallback: string): Promise<string> {
  try {
    const text = await err?.response?.data?.text?.();
    if (text) return JSON.parse(text).error || fallback;
  } catch {
    /* keep the fallback */
  }
  return fallback;
}
